import React, { FC, useLayoutEffect } from 'react';
/** */
export const PasswordRecovery: FC = () => {
    useLayoutEffect(() => {
        window.open(`${process.env.REACT_APP_SSO_CLIENT}/restore/?return=${window.location.origin}`, '_self');
    }, []);
    return null;
};
